import { createReducer, createSetter } from "@/redux/helpers/reducer";
import { STATUS } from "@/utils/constants";

import * as actions from "./purchase-products-modal.actions";
const initialState = {
  lists: [],
  suppliersList: [],
  isFetchingSuppliersStatus: STATUS.IDLE,
  isFetchingPurchaseProductsStatus: STATUS.IDLE,
  isCreating: false,
  isGroupedProducts: true,
  hasFormSubmitted: false,
  selectedSupplierForAll: null,
  isCreatePurchaseOrderModalOpen: false,
  isCreatingPurchaseOrderModalOpen: false,
  isCreatedPurchaseOrderModalOpen: false,
  selectedProductUids: [],
  createdPoUids: [],
};

export default createReducer(initialState, {
  [actions.setLists]: createSetter("lists"),
  [actions.setSuppliersList]: createSetter("suppliersList"),
  [actions.setIsFetchingSuppliersStatus]: createSetter("isFetchingSuppliersStatus"),
  [actions.setIsFetchingPurchaseProductsStatus]: createSetter("isFetchingPurchaseProductsStatus"),
  [actions.setIsCreating]: createSetter("isCreating"),
  [actions.setIsGroupedProducts]: createSetter("isGroupedProducts"),
  [actions.setHasFormSubmitted]: createSetter("hasFormSubmitted"),
  [actions.setSelectedSupplierForAll]: createSetter("selectedSupplierForAll"),
  [actions.setIsCreatePurchaseOrderModalOpen]: createSetter("isCreatePurchaseOrderModalOpen"),
  [actions.setIsCreatingPurchaseOrderModalOpen]: createSetter("isCreatingPurchaseOrderModalOpen"),
  [actions.setIsCreatedPurchaseOrderModalOpen]: createSetter("isCreatedPurchaseOrderModalOpen"),
  [actions.setSelectedProductUids]: createSetter("selectedProductUids"),
  [actions.setCreatedPoUids]: createSetter("createdPoUids"),
  [actions.reset]: () => ({ ...initialState }),
});
